import Divider from "components/common/divider";
import { SectionContent } from "components/common/sectionContent";
import graphicRating from "../../images/graphics/graphic-rating.png";

const ProductLifecycleSection = () => {
  return (
    <section className="sec-prod-lifecycle-section">
      <SectionContent>
        <div className="sec-lifecycle-expertise-grid">
          <img src={graphicRating} alt="Cyber Rating Graphic" className="cyber-rating" />
          <Divider vertical spacing="lg" />
          <div>
            <h3>
              <b>Security Guides</b> Our Product Life Cycle
            </h3>
            <p className="p-1">
              <b>
                As a security-first organization, we prioritize the trust service criteria (TSC) across all elements of
                our business.
              </b>{" "}
              We architected Flueid Decision and Flueid Transact from the ground up using a zero-trust security
              methodology to ensure there is no central data aggregation, providing clients with hardened platforms that
              adhere to current NIST CSF standards.
            </p>
          </div>
        </div>
      </SectionContent>
    </section>
  );
};

export default ProductLifecycleSection;
